import { useEffect } from 'react';
import config from '../../Config';

/**
 * Компонент для подключения аналитики
 * Поддерживает: Google Analytics 4, Yandex Metrika
 * 
 * Для настройки добавьте в Config.js:
 * - googleAnalyticsId: 'G-XXXXXXXXXX'
 * - yandexMetrikaId: 'XXXXXXXX'
 */
const Analytics = () => {
  useEffect(() => {
    // Google Analytics 4
    if (config.googleAnalyticsId) {
      // Добавляем gtag.js
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${config.googleAnalyticsId}`;
      document.head.appendChild(gtagScript);

      // Инициализация gtag
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', config.googleAnalyticsId, {
        page_title: document.title,
        page_location: window.location.href,
        send_page_view: true
      });

      window.gtag = gtag;
    }

    // Yandex Metrika
    if (config.yandexMetrikaId) {
      // Добавляем скрипт Яндекс.Метрики
      const ymScript = document.createElement('script');
      ymScript.type = 'text/javascript';
      ymScript.innerHTML = `
        (function(m,e,t,r,i,k,a){
          m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
          m[i].l=1*new Date();
          k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
        })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
        
        ym(${config.yandexMetrikaId}, "init", {
          clickmap:true,
          trackLinks:true,
          accurateTrackBounce:true,
          webvisor:true,
          ecommerce:"dataLayer"
        });
      `;
      document.head.appendChild(ymScript);

      // Noscript версия для пользователей без JS
      const ymNoScript = document.createElement('noscript');
      ymNoScript.innerHTML = `
        <div><img src="https://mc.yandex.ru/watch/${config.yandexMetrikaId}" 
        style="position:absolute; left:-9999px;" alt="" /></div>
      `;
      document.body.appendChild(ymNoScript);
    }
  }, []);

  return null;
};

/**
 * Функция для отправки события в Google Analytics
 * @param {string} eventName - Название события
 * @param {object} params - Параметры события
 */
export const trackGAEvent = (eventName, params = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, params);
  }
};

/**
 * Функция для отправки события в Yandex Metrika
 * @param {string} eventName - Название события
 * @param {object} params - Параметры события
 */
export const trackYMEvent = (eventName, params = {}) => {
  if (window.ym && config.yandexMetrikaId) {
    window.ym(config.yandexMetrikaId, 'reachGoal', eventName, params);
  }
};

/**
 * Функция для отправки события во все подключенные аналитики
 * @param {string} eventName - Название события
 * @param {object} params - Параметры события
 */
export const trackEvent = (eventName, params = {}) => {
  trackGAEvent(eventName, params);
  trackYMEvent(eventName, params);
};

/**
 * Функция для отслеживания просмотра страницы
 * @param {string} pagePath - Путь страницы
 * @param {string} pageTitle - Заголовок страницы
 */
export const trackPageView = (pagePath, pageTitle) => {
  if (window.gtag && config.googleAnalyticsId) {
    window.gtag('config', config.googleAnalyticsId, {
      page_path: pagePath,
      page_title: pageTitle
    });
  }
  if (window.ym && config.yandexMetrikaId) {
    window.ym(config.yandexMetrikaId, 'hit', pagePath, {
      title: pageTitle
    });
  }
};

export default Analytics;
